import { HsVector3 } from '../objects/vector3.class';

export class HsLineSegment {
  public start: HsVector3;
  public end: HsVector3;

  constructor(startX: number, startY: number, startZ: number, endX: number, endY: number, endZ: number) {
    this.start = new HsVector3(startX, startY, startZ);
    this.end = new HsVector3(endX, endY, endZ);
  }

  /**
   * Sets set.
   * @param start start.
   * @param end end.
   * @returns Result value.
   */
  public set(start: HsVector3, end: HsVector3): HsLineSegment {
    this.start.copy(start);
    this.end.copy(end);
    return this;
  }

  /**
   * Copies copy.
   * @returns Result value.
   */
  public copy(other: HsLineSegment): HsLineSegment {
    this.start.copy(other.start);
    this.end.copy(other.end);
    return this;
  }

  /**
   * Gets center.
   * @param center center.
   * @returns Result value.
   */
  public getCenter(center: HsVector3): HsVector3 {
    return HsVector3.average(this.start, this.end, center);
  }

  /**
   * Gets length.
   * @returns Result value.
   */
  public getLength(): number {
    return HsVector3.distance(this.start, this.end);
  }

  /**
   * Gets vector.
   * @param vector vector.
   * @returns Result value.
   */
  public getVector(vector: HsVector3): HsVector3 {
    return vector.subtractVectors(this.end, this.start);
  }

  /**
   * Builds copy.
   * @param source source.
   * @returns Result value.
   */
  public static makeCopy(source: HsLineSegment): HsLineSegment {
    return new HsLineSegment(
      source.start.values[0],
      source.start.values[1],
      source.start.values[2],
      source.end.values[0],
      source.end.values[1],
      source.end.values[2]
    );
  }
}
